import {useMutation} from "@apollo/client";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {GQL_ACCOUNTUSER_DELETE, GQL_ACCOUNTUSERS_QUERY} from "@/lib/queries/accounts.ts";
import {AccountUser} from "@/lib/types/accounts.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

export interface UserActionDeleteProps {
  user: AccountUser;
  show: boolean;
  setShow: (show: boolean) => void;
}

export const UserActionDelete = ({user, show, setShow}: UserActionDeleteProps) => {
  const [deleteUser, {data, reset, loading}] = useMutation<GraphQLResponse<null>>(GQL_ACCOUNTUSER_DELETE, {
    refetchQueries: [GQL_ACCOUNTUSERS_QUERY],
  });

  const handleSubmit = async () => {
    const response = await deleteUser({
      variables: {
        id: user.id,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
    }
  };

  const serverErrors = data?.response?.status === ResponseStatus.ERROR ? data?.response?.message.__all__ : [];

  return (
    <>
      <DeleteActionDialog
        show={show}
        loading={loading}
        title={serverErrors?.length > 0 ? "Unable to Delete User" : "Delete User"}
        onConfirm={handleSubmit}
        onCancel={() => {
          setShow(false);
          reset();
        }}
      >
        {serverErrors?.length > 0
          ? serverErrors[0]
          : `Are you sure you want to delete User "${user.first_name} ${user.last_name}"?`}
      </DeleteActionDialog>
    </>
  );
};
